import { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

import { Form, Select, Text } from '../../../Components/Form';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { serverErrorHandler, sportTypes } from '../../../Utils/Helpers';

const validationSchema = Yup.object({
  title: Yup.string()
    .typeError('عنوان الزامی است')
    .required('عنوان الزامی است')
    .max(190, 'عنوان نمی تواند بیشتر از 190 کاراکتر باشد'),
  type: Yup.number()
    .typeError('نوع رشته الزامی است')
    .required('نوع رشته الزامی است'),
});

const Create = () => {
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const { post } = useApi();
  const { error, success } = useToast();
  const navigate = useNavigate();

  const submitForm = async (values, setSubmitingForm) => {
    setFormSubmitLoaing(true);
    await post(
      '/sport',
      values,
      (res) => {
        success(`رشته "${values?.title}" باموفقیت ایجاد شد.`);
        setFormSubmitLoaing(false);
        navigate('/sport');
      },
      (err) => {
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error(`رشته "${values?.title}" به علت خطا ایجاد نشد.`);
        }
        setFormSubmitLoaing(false);
      },
    );
  };
  return (
    <Master>
      <TitleBar
        title='ایجاد رشته'
        showBackBtn={true}
        showCreateBtn={false}
        showFilterBtn={false}
        backPath='/sport'
      />
      <Form
        initialValues={{
          title: '',
          type: 0,
        }}
        loading={formSubmitLoading}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        <div className='row'>
          <div className='col-12 col-md-8'>
            <div className='row'>
              <div className='col-12'>
                <Text
                  title='عنوان'
                  name='title'
                  serverError={serverErrors.title}
                />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-4'>
            <div className='col-12'>
              <Select
                title='نوع رشته'
                name='type'
                serverError={serverErrors?.type}
                options={sportTypes}
              />
            </div>
          </div>
        </div>
      </Form>
    </Master>
  );
};

export default Create;
